import { Expose } from 'class-transformer'

export class EbookByUserIdType {
  @Expose() ebookId: number

  @Expose() ebookTitle: string
}
